import React from 'react';
import classnames from 'classnames';
import { Provider } from 'mobx-react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import { HomePage } from 'pages/home';
import { ImprintPage } from 'pages/imprint';
import { NotFoundPage } from 'pages/not-found';
import { LecturesPage } from 'pages/lectures';
import { TherapiesPage } from 'pages/therapies';
import { ConsultationPage } from 'pages/consultation';
import { PrivacyPage } from 'pages/privacy';
import { TermsPage } from 'pages/terms';
import { CopyrightPage } from 'pages/copyright';
import { ContactPage } from 'pages/contact';
import { PartnersPage } from 'pages/partners';

import { HeaderComponent as Header } from 'components/header';
import { FooterComponent as Footer } from 'components/footer';
import { ApplicationLayout } from 'layouts/app';
import { HeaderLayout } from 'layouts/header';
import { ContentLayout } from 'layouts/content';
import { FooterLayout } from 'layouts/footer';
import { BurgerMenuComponent as BurgerMenu } from 'components/menus';
import { PrivacyMessage } from 'components/messages';

import { LecturesStore } from 'modules/lectures';
import { TherapiesStore } from 'modules/therapies';
import { AnalyticsStore } from 'modules/analytics';
import { PrivacyStore } from 'modules/privacy';
import { ConfigStore } from 'modules/config';
import { PartnersStore } from 'modules/partners';

import 'react-select/dist/react-select.css';
const styles = require('./application.styles.scss');


class App extends React.Component {
  stores = null;

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };
  }

  componentWillMount() {
    this.stores = {
      lecturesStore: new LecturesStore(),
      therapiesStore: new TherapiesStore(),
      analyticsStore: new AnalyticsStore(process.env.REACT_APP_GA_ID),
      privacyStore: new PrivacyStore(sessionStorage),
      configStore: new ConfigStore(),
      partnersStore: new PartnersStore(),
    };

    this.stores.analyticsStore.init();
    this.stores.privacyStore.init();
  }

  render() {
    const classname = classnames(styles.App, {
      [styles.MenuOpen]: this.state.menuOpen
    });

    return (
      <div className={classname}>
        <Provider {...this.stores}>
          <Router>
            <ApplicationLayout>
              <PrivacyMessage />
              <BurgerMenu
                isOpen={this.state.menuOpen}
                onStateChange={this.onMenuStateChange}
              />
              <HeaderLayout>
                <Header />
              </HeaderLayout>
              <ContentLayout>
                <Switch>
                  <Route exact path='/' component={HomePage} />
                  <Route path='/lectures' component={LecturesPage} />
                  <Route path='/therapies' component={TherapiesPage} />
                  <Route path='/consultation' component={ConsultationPage} />
                  <Route path='/contact' component={ContactPage} />
                  <Route path='/imprint' component={ImprintPage} />
                  <Route path='/privacy-policy' component={PrivacyPage} />
                  <Route path='/terms' component={TermsPage} />
                  <Route path='/copyright' component={CopyrightPage} />
                  <Route path='/partners' component={PartnersPage} />
                  <Route component={NotFoundPage} />
                </Switch>
              </ContentLayout>
              <FooterLayout>
                <Footer />
              </FooterLayout>
            </ApplicationLayout>
          </Router>
        </Provider>
      </div>
    );
  }

  onMenuStateChange = (bool) => {
    this.setState({ menuOpen: bool });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js